module.exports = __webpack_public_path__ + "static/media/header.ba2107de.png";